// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","unregister":"Button_unregister__H7BGB"};